import { useState } from 'react';

import { Button, cn, Dialog, DialogContent, DialogTrigger } from '@design-system';

import { Loader2 } from 'lucide-react';

interface TrialVideoDialogProps {
  videoUrl: string;
}

export function TrialVideoDialog({ videoUrl }: TrialVideoDialogProps) {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  function resetLoadingState(open: boolean) {
    if (!open) setIsVideoLoaded(false);
  }

  return (
    <Dialog onOpenChange={resetLoadingState}>
      <DialogTrigger asChild>
        <Button variant="outline">Watch Video</Button>
      </DialogTrigger>
      <DialogContent className="max-h-[95vh] overflow-hidden border-none p-0 sm:max-w-5xl">
        <div
          className={cn('relative w-full', {
            'animate-pulse': !isVideoLoaded,
          })}
        >
          {!isVideoLoaded && (
            <div className="bg-background absolute inset-0 z-10 grid size-full place-items-center">
              <div className="mx-auto space-y-4 text-center font-medium">
                <Loader2 className="mx-auto size-8 animate-spin" />
                <p>Loading Video</p>
              </div>
            </div>
          )}
          <div className="relative aspect-video w-full">
            <iframe
              allowFullScreen
              src={videoUrl}
              loading="lazy"
              allow="autoplay; fullscreen"
              className="absolute inset-0 size-full"
              onLoad={() => setIsVideoLoaded(true)}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
